import React, { memo, type ReactNode } from 'react';

import { Stack } from '@/components/layout';
import { Text } from '@/components/ui';
import { createStyles, useScaling } from '@/hooks';
import { guardianColors } from '@/theme/colors';

type KitNotesEmptyProps = {
  /** Illustration shown above the message (image or icon, sized by the caller). */
  illustration: ReactNode;
  message: string;
};

function KitNotesEmpty({ illustration, message }: KitNotesEmptyProps) {
  const styles = useStyles();
  const { scale } = useScaling();

  return (
    <Stack align="center" gap={scale(12)} style={styles.root}>
      {illustration}
      <Text variant="Font Guardian App/Subtitle/Subtitle 14 Bold" style={styles.message}>
        {message}
      </Text>
    </Stack>
  );
}

const useStyles = createStyles(({ scale }) => ({
  root: {
    paddingTop: scale(48),
  },
  message: {
    color: guardianColors['6'],
    textAlign: 'center',
  },
}));

export default memo(KitNotesEmpty);
